<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <h5 style="color: #000f7f">Please add any additional comments for our evaluation:</h5>
    </div>

    <div class="md-layout-item md-size-100">
      <md-field>
        <label>Comments</label>
        <md-textarea
          v-model="comments"
          style="color: #000f7f"
          data-vv-name="comments"
          type="textarea"
          name="comments"
        />
        <slide-y-down-transition>
          <md-icon v-show="errors.has('comments')" class="error">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon v-show="!errors.has('comments') && touched.comments" class="success">done</md-icon>
        </slide-y-down-transition>
      </md-field>
    </div>
  </div>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions"
import { mapGetters } from "vuex"
export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      comments: "",
      select: null,
      touched: {
        comments: false
      },
      modelValidations: {
        comments: {
          required: false
        }
      }
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["drComments"])
  },
  watch: {
    street() {
      this.touched.comments = true
    }
  },
  mounted() {
    this.comments = this.drComments.comments ? this.drComments.comments : ""
  },
  methods: {
    nextTab() {
      this.$emit("complete")
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    validate() {
      this.storeValues()
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res)
        return res
      })
    },
    storeValues() {
      this.drComments.comments = this.comments
    }
  }
}
</script>
<style></style>
